import { FactoryArg } from "imask";
import { MaskedInputProps, MaskedInputControlledProps, MaskedInput, MaskedInputControlled } from "./MaskedInput";

const mask = ["00000", "00000-0000"];
const validationExp = /^\d{5}(-\d{4})?$/;
const placeholder = "12345";
const validationMessage = "Invalid Zip Code";

export const MaskedZipCodeInput = <Opts extends FactoryArg>(props: Partial<MaskedInputProps<Opts>>) => {
    return <MaskedInput type="tel" placeholder={placeholder} mask={mask} {...props} />;
};

export const MaskedZipCodeInputControlled = <Opts extends FactoryArg>({
    name,
    rules,
    invalidMessage,
    ...props
}: { invalidMessage?: string; name: string } & Partial<MaskedInputControlledProps<Opts>>) => {
    return (
        <MaskedInputControlled
            name={name}
            type="tel"
            placeholder={placeholder}
            mask={mask}
            rules={{ pattern: { value: validationExp, message: invalidMessage || validationMessage }, ...rules }}
            {...props}
        />
    );
};
